import React from "react";
import { useHistory } from "react-router";
import "./Backbutton.scss";

function Backbutton({ isDsPage }) {
  let history = useHistory();
  console.log(isDsPage);
  return (
    <div
      className="backButton"
      style={{
        // background: isDsPage ? "black" : "white",
        // color: isDsPage ? "white" : "black",
        zIndex: 2,
      }}
    >
      <button onClick={() => history.goBack()} className="origin">
        BACK
      </button>
      <button onClick={() => history.goBack()} className="effect">
        BACK
      </button>
    </div>
  );
}

export default Backbutton;
